'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-07
 */

import myaccount from './my-account.vue'

const routes = [
	{
		path: '/my-account',
		name: 'myaccount',
		props: false,
		component: myaccount,
		meta: { authRequired: true }
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/my-account/index.js